import React, { useState } from "react";
import {createUser} from '../../../lib/auth'
import {addData } from "../../../lib/profiles"
import { useNavigate } from 'react-router-dom';
import {  RoleSelectforNewRecord } from "../../ui/myselect";
//import {useAuth} from "../../../usercontext";

export default function AdminStudentEdit() {

  const [email, setEmail] = useState();
  const [validationError, setValidationError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [role, setRole] = useState();

  const navigate = useNavigate();


  console.log("role",role);

  const handleSubmit = async (e) => {
      e.preventDefault();

      const { data, error } = await createUser(email,'12345',role);

      console.log("data", error);
      
      if(data.user)
      {
      await addData({
        id: data.user.id,
        email: email,
        role:role
       // companyId: companyId
      });
      navigate(`/admin/admin-studentstep2/${data.user.id}/Add`);
 }
      

 if(error)
 {
    setValidationError(true);
    setErrorMessage("Error : " + error.message);
    
 }
      
   
/*
burada bazı  bilgileri ekleyebiliriz.

    const { data, error } = await supabase.auth.updateUser({
      data: { hello: 'world' }
    })
*/
    /*
    handle_new_user
begin
  insert into public.profiles (id, full_name, avatar_url,email)
  values (new.id, new.raw_user_meta_data->>'full_name', new.raw_user_meta_data->>'avatar_url',new.email);
  return new;
end
    */ 
  };

  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p-2">
                    <h3>Add Student</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Mail
                            </label>
                            <input
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter Email"
                              required
                            />
                          </div>
                          <div className="form-group">
                          <label className="form-control-label">
                              Role 
                            </label>
                            <RoleSelectforNewRecord value={role} setValue={setRole}/>
                          </div>
                          {validationError && (
                            <div className="alert alert-danger">
                              {errorMessage}
                            </div>
                          )}
                          
                        </div>

                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            Next Step  {">>"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
